import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=469abc9b"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469abc9b')) {
      api.createRecord('469abc9b', component.options)
    } else {
      api.reload('469abc9b', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=469abc9b", function () {
      api.rerender('469abc9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Configuraciones/ListaNegra/Index.vue"
export default component.exports